import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { useIsMobileResolution } from 'utils/hooks/useIsMobileResolution';
import { MONTH_PICKER, SINGLE_OPTION_SELECT, SUB_STAGE_SELECT } from 'modules/questionnaire/questionTypes';
import QuestionnaireProgress from './components/QuestionnaireProgress';
import Question from './components/Question';
import { EmbeddedQuestionnaireNavigator } from './components/EmbeddedQuestionnaireNavigator';
import QuestionnaireNavigator from './components/QuestionnaireNavigator';
import styles from './styles';
import { useQuestionnaireData } from './context';

const useStyles = makeStyles(styles);

export const QuestionnaireView = ({
  provider,
  embedded,
  handleSubmit,
  handleSkipButton,
  handlePreviousButton,
  isLast,
  profile,
  currentQuestion,
  questionRef,
  isCurrentQuestionAnswered,
  isCurrentQuestionAnswerChanged,
  isUserUpdating,
  isPreviousButtonDisable,
  setAbilityToChangePrevBtnEvent,
  setAbilityToChangeSkipBtnEvent,
}) => {
  const classes = useStyles();
  const isMobileResolution = useIsMobileResolution();
  const { showNextButton = true } = useQuestionnaireData();

  const shouldNextButtonBeShown = !!((provider || isMobileResolution || embedded)
    && (embedded ? isCurrentQuestionAnswerChanged : isCurrentQuestionAnswered)
    && ![SINGLE_OPTION_SELECT, MONTH_PICKER, SUB_STAGE_SELECT].includes(currentQuestion.type)
    && showNextButton);

  return (
    <div className={cx({ [classes.providerQuestionnaireProviderWrapper]: provider })}>
      {!embedded && (
        <Grid item className={`${provider ? classes.providerProgressMenu : classes.progressMenu} progress-menu`}>
          <QuestionnaireProgress profile={profile} />
        </Grid>
      )}
      <Grid className={provider ? classes.providerRootQuestionnaire : classes.root}>
        <Grid className={cx(classes.question, { [classes.providerQuestion]: provider })} item>
          <Question
            forwardedRef={questionRef}
            handleSubmit={handleSubmit}
            question={currentQuestion}
            setAbilityToChangePrevBtnEvent={setAbilityToChangePrevBtnEvent}
            setAbilityToChangeSkipBtnEvent={setAbilityToChangeSkipBtnEvent}
          />
          {embedded && shouldNextButtonBeShown && !isUserUpdating ? (<EmbeddedQuestionnaireNavigator />) : null}
          {(isUserUpdating && provider) || embedded ? null : (
            <QuestionnaireNavigator
              shouldSkipButtonBeShown
              handleSkipButton={handleSkipButton}
              handlePreviousButton={handlePreviousButton}
              disablePreviousButton={isPreviousButtonDisable}
              disableSkipButton={isLast}
              shouldNextButtonBeShown={shouldNextButtonBeShown}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

QuestionnaireView.propTypes = {
  questionRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  handleSubmit: PropTypes.func.isRequired,
  handleSkipButton: PropTypes.func.isRequired,
  handlePreviousButton: PropTypes.func.isRequired,
  setAbilityToChangeSkipBtnEvent: PropTypes.func.isRequired,
  setAbilityToChangePrevBtnEvent: PropTypes.func.isRequired,
  isLast: PropTypes.bool.isRequired,
  isUserUpdating: PropTypes.bool.isRequired,
  isPreviousButtonDisable: PropTypes.bool.isRequired,
  isCurrentQuestionAnswered: PropTypes.bool.isRequired,
  isCurrentQuestionAnswerChanged: PropTypes.bool.isRequired,
  profile: PropTypes.object.isRequired,
  currentQuestion: PropTypes.shape({
    type: PropTypes.string.isRequired,
  }).isRequired,
  provider: PropTypes.any,
  embedded: PropTypes.bool,
};
